export default __webpack_public_path__ + "static/media/NextRightIcon.60b2c9cb.svg";